import React from "react";
import { Route } from "react-router";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Layout } from "components/Layout";
import { Home } from "components/Home";
import { Results } from "components/Results";
import { Alert } from "components/Alert";
import { Modal } from "components/Modal";
import { Terms } from "components/Terms";
import { Download } from "components/standalone/Download";
import { Logout } from "router/Logout";
import { Personal } from "components/topic/Personal";
import { RelevantSites } from "components/RelevantSites";
import { SearchFilter } from "components/search/SearchFilter";
import { SearchBar } from "components/search/SearchBar";
import { HandleQueryString } from "components/search/HandleQueryString";
import { Account } from "account";
import { StatusType } from "data/Types";
import { useSearchStatus } from "hooks";
import styles from "App.module.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faEdit,
  faTimes,
  faCheck,
  faComment,
  faStream,
  faUser,
  faQuoteLeft,
  faFilter,
  faDownload,
  faSearch,
  faBookmark,
  faExternalLinkAlt,
  faFilePdf,
  faGlobe,
  faLock,
  faHistory,
  faSignInAlt,
  faSignOutAlt,
  faEye,
  faSpinner,
  faFileUpload,
  faStar,
  faCaretDown,
  faCaretRight,
  faRedo,
  faTrash,
  faExclamationTriangle,
  faUserCircle,
  faFolderPlus,
  faUserPlus,
  faNewspaper,
  faEllipsisV,
  faSyncAlt,
  faRegistered,
  faFlagUsa,
  faFingerprint,
  faChessKnight,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";
import {
  faGoogle,
  faWikipediaW,
  faMicrosoft,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faInfo,
  faEdit,
  faTimes,
  faCheck,
  faComment,
  faStream,
  faUser,
  faQuoteLeft,
  faFilter,
  faDownload,
  faSearch,
  faBookmark,
  faExternalLinkAlt,
  faFilePdf,
  faGlobe,
  faLock,
  faHistory,
  faSignInAlt,
  faSignOutAlt,
  faEye,
  faSpinner,
  faFileUpload,
  faStar,
  faCaretDown,
  faCaretRight,
  faRedo,
  faTrash,
  faExclamationTriangle,
  faUserCircle,
  faFolderPlus,
  faUserPlus,
  faNewspaper,
  faEllipsisV,
  faSyncAlt,
  faRegistered,
  faFlagUsa,
  faFingerprint,
  faChessKnight,
  faAngleLeft,
  faGoogle,
  faWikipediaW,
  faMicrosoft
);

const App = () => {
  const [status] = useSearchStatus();
  const MainComponent = !(status & StatusType.Queried) ? Home : Results;
  return (
    <>
      <HandleQueryString />
      <Layout
        className={`${styles.app} ${
          !(status & StatusType.Queried) ? styles.splash : styles.query
        }`}
        fluid={true}
      >
        <Container tag="header" fluid className={styles.header}>
          <SearchBar />
        </Container>
        <nav className={styles.nav}>
          <SearchFilter />
          <Personal />
          <RelevantSites />
        </nav>
        <Container tag="main" className={styles.main} fluid>
          <Route path="/account/logout" component={Logout} />
          <Route path="/account" component={Account} />
          {false && <Route path="/terms" component={Terms} />}
          <Route path="/download" component={Download} />
          <Route exact path="/" component={MainComponent} />
        </Container>
        <footer className={`text-center p-2 ${styles.footer}`}>
          Copyright KnowING IPR © All rights reserved 2019-
          {new Date().getFullYear()}. ·{" "}
          <a
            href="http://www.interreg-danube.eu/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>{" "}
          · <Link to="/download">Download</Link>
        </footer>
      </Layout>
      <Alert />
      <Modal />
    </>
  );
};
export default App;
